<template>
    <div>
      <Head title="Admin" />
      <v-container class="grey lighten-5">
        <v-card>
          <v-card-title>
            Categories
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              @input="getDataFromApi()"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            
            <v-spacer></v-spacer>
            <v-btn
            class="mx-2"
            fab
            dark
            color="primary"
            @click="addNew"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="list"
            :options.sync="options"
            :items-per-page="itemsPerPage"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
          >
          <template v-slot:item.active="{ item }">
                <v-icon v-if="item.active == 1" color="success">mdi-check</v-icon>
                <v-icon v-if="item.active == 0" color="error">mdi-close-circle-outline</v-icon>
            </template> 
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="edit(item.id)"
            >
              mdi-pencil
            </v-icon>
            
          </template>
        </v-data-table>
        </v-card> 

        <v-dialog v-model="dialogAdd"  fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialogAdd = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="dialogType == 'add'">Add New Category</v-toolbar-title>
          <v-toolbar-title v-if="dialogType == 'edit'">Edit {{newcategory.name}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                v-if="dialogType=='add'"
              dark
              text
              @click="saveAddDialog"
            >
              Add
            </v-btn>
            <v-btn
                v-if="dialogType=='edit'"
              dark
              text
              @click="saveEditDialog"
            >
              Update
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container v-if="errors">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-alert type="error">
                      <ul>
                        <li v-for="e in errors">
                          {{ e[0] }}
                        </li>
                      </ul>
                      
                    </v-alert>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row>
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcategory.title"
                      label="Title"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcategory.alias"
                      label="Alias"
                      hint="No spaces or special characters, e.g. my-category"
                      required
                    ></v-text-field>
                  </v-col>
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                    <v-switch
                      v-model="newcategory.active"
                      label="Active"
                    ></v-switch>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-textarea
                      v-model="newcategory.tags"
                      label="Tags"
                      hint="Separate by comma"
                      required
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeAddDialog"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="dialogType == 'add'"
                color="blue darken-1"
                text
                @click="saveAddDialog"
              >
                Add New
              </v-btn>
              <v-btn
                v-if="dialogType == 'edit'"
                color="blue darken-1"
                text
                @click="saveEditDialog"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" >
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete = !dialogDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'
  
  const passwordLength = 12
  const passwordChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

  export default {
    props: {
      categories: Array,
      users:Array,
      regions:Array,
    },
    components: {
      Head,
    },
    layout: Layout,
    data() {
        return {
            list: [],
            keyword: "",
            total: this.categories.length,
            itemsPerPage: 20,
            loading: false,
            loadingAdd: false,
            options: {},
            search: "",            
            errors:false,

            headers: [
              { text: 'ID', value:'id'},
              { text: 'Title', value:'title'},
              { text: 'Active', value:'active'},
              { text: 'Actions', value:'actions'}

            ],
            newcategory: {
              title:"",//
              tags:"",
              alias: "",//
              active: false,
            },
            dialogType:'add',
            dialogAdd: false,
            dialogDelete: false
        }
    },
    watch: {
      options: {
        handler () {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    created() {
      this.list = JSON.parse(JSON.stringify(this.categories));
    },
    methods: {
      edit(id) {
        
        this.errors=false;
        console.log('attempting to edit id ',id)
        axios.get("/admin/categories/get/"+id).then((response) => {
            console.log('edit got response',response.data)
            if (response && response.data)
            {
                this.newcategory = response.data
                this.dialogAdd = true;
                this.dialogType='edit';
            }
        });
      },
      addNew(){
        this.dialogType='add';
        
        this.errors=false;
        Object.keys(this.newcategory).forEach(key => {
            if (key == 'photo')
                this.newcategory.key = []
            else
                this.newcategory[key] = "";
        });
        this.dialogAdd = true;
      },
      getDataFromApi () {
        this.loading = true
        console.log('getting request',this.options)
        var params = JSON.parse(JSON.stringify(this.options));
        params.filters = { search: this.search, role: this.role };

        axios.get("/admin/categories/list",{ params: params }).then((response) => {
          this.list = response.data.list
          this.total= response.data.total;
          this.loading = false;
        });
      },
      deleteItemConfirm () {
        this.closeDelete()
      },

      closeAddDialog () {
        this.dialogAdd = false
      },

      closeDelete () {
        this.dialogDelete = false
        
      },
      saveEditDialog () {
        
        this.errors=false;
        this.loadingAdd=true;
        const formData = new FormData()
        Object.keys(this.newcategory).forEach(key => formData.append(key, this.newcategory[key]));
        axios.post("/admin/categories/update",formData).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Edit failed');
          
            console.log('edit response',response)
            this.loadingAdd = false;
        }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      saveAddDialog () {
        this.loadingAdd=true;
        this.errors=false;
        console.log('adding category',this.newcategory)
        const formData = new FormData()
        Object.keys(this.newcategory).forEach(key => formData.append(key, this.newcategory[key]));
        axios.post("/admin/categories/add",formData).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Add failed');
          
            console.log('add response',response)
          this.loadingAdd = false;
        }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      
    },
  }
  </script>
  